import { getClaimReasons } from '~/utils/line-item-claim';
import { makeLineItemClaimLoader } from '~/utils/routing';

export const { loader, useLoaderData: useReasonData } = makeLineItemClaimLoader(
  ({ context: { claim } }) => {
    const reasons = getClaimReasons(claim).map(({ id, name }) => ({
      name,
      id,
    }));

    return { reasons, claim };
  },
);
